/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TrainingType {
    Season = 'SEASON',
    AdHoc = 'AD_HOC'
}


export function instanceOfTrainingType(value: any): boolean {
    for (const key in TrainingType) {
        if (Object.prototype.hasOwnProperty.call(TrainingType, key)) {
            if (TrainingType[key as keyof typeof TrainingType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrainingTypeFromJSON(json: any): TrainingType {
    return TrainingTypeFromJSONTyped(json, false);
}

export function TrainingTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingType {
    return json as TrainingType;
}

export function TrainingTypeToJSON(value?: TrainingType | null): any {
    return value as any;
}

export function TrainingTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TrainingType {
    return value as TrainingType;
}

